<template>
  <div class="echart-common">
    <div class="echart-common-title">{{ text }}</div>
    <div :id="el" :style="echartStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'EchartCommon',
  props: {
    text: String,
    el: String,
    echartStyle: Object,
  },
}
</script>

<style lang='scss'>
.echart-common {
  .echart-common-title {
    height: 32px;
    font-size: 16px;
    line-height: 32px;
    padding-left: 14px;
    background-image: linear-gradient(
      0deg,
      #28466f 24%,
      rgba(40, 70, 111, 0.86) 38%,
      rgba(39, 54, 78, 0.5) 73%,
      #252a34 100%
    );
  }
}
</style>